import { styled } from '@mui/material/styles';
import { AppBar as MuiAppBar, Toolbar, Box, Typography, IconButton } from '@mui/material';

interface AppBarProps {
  open?: boolean;
}

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: '#162238',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

export const StyledToolbar = styled(Toolbar)({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0 24px',
  minHeight: '64px',
});

export const LeftSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const RightSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const Title = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '20px',
  color: 'white',
  lineHeight: '1.2',
});

export const HeaderIconButton = styled(IconButton)({
  color: 'white',
  marginLeft: '8px',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
});
